import { getUserInfo } from 'libs/consumer/providers/src/lib/softManager/utils';
import { IDetailsStepProps } from './detailsStep.models';
import { ButtonDiv, DetailsWrapper } from './detailsStep.style';
import { ButtonContainer } from '../../fallbackModal.style';
import { ButtonCBU, ProductDetail } from '@vfit/consumer/components';

const DetailsStep = ({
  details,
  modalInfo,
  onButtonClick,
  onSecondButtonClick,
}: IDetailsStepProps) => (
  <DetailsWrapper>
    <ProductDetail
      trackingOpt={{
        event: ['ui_interaction'],
        event_label: 'offer details',
        opts: { event_category: 'users', event_action: 'click' },
        visitorTrackingOpts: getUserInfo(),
        disableInitialTrack: true,
      }}
      details={details}
      modalInfo={modalInfo}
    />
    <ButtonContainer>
      <ButtonDiv>
        <ButtonCBU onClick={onButtonClick} variant={details.firstButtonVarian || 'primary'}>
          {details.firstButtonLabel}
        </ButtonCBU>
        {onSecondButtonClick && details.secondButtonLabel && !details.disableSecondAction && (
          <ButtonCBU
            onClick={onSecondButtonClick}
            variant={details.seconButtonVarian || 'secondary'}
          >
            {details.secondButtonLabel}
          </ButtonCBU>
        )}
      </ButtonDiv>
    </ButtonContainer>
  </DetailsWrapper>
);

export default DetailsStep;
